import React from "react";
import BlogCreadoresSerCreador from "../../components/blogs/BlogDetails/BlogCreadoresSerCreador";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

export default function HelpCreatorComoSerCreadorDeContenido() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        HeaderTitle="Como ser Creador"
        PageTitle="Como ser Creador de Contenido"
        Parent="Ayuda"
      />
      <BlogCreadoresSerCreador />
      <Footer />
    </Layout>
  );
}
